import {Title} from '@radix-ui/react-toast';
import clsx from 'clsx';

type Props = React.ComponentPropsWithRef<typeof Title>;
export function ToastTitle(props: Props): React.JSX.Element {
  return (
    <Title
      {...props}
      className={clsx([
        'text-sm font-semibold text-slate12 [grid-area:title]',
        props.className,
      ])}
    />
  );
}

ToastTitle.displayName = 'ToastTitle';
